<div class="activity-moderators">
	@if (!isLoading()) {
		<mat-form-field appearance="outline" class="activity-moderators__field">
			<mat-label>{{ 'activity-editor-moderators-label' | translate }}</mat-label>
			<mat-chip-grid
				#moderatorGrid
				[attr.aria-label]="'activity-editor-moderators-selection-label' | translate">
				@for (moderator of selectedModerators(); track moderator.user_id) {
					<mat-chip-row (removed)="requestRemoveModerator(moderator)">
						{{ moderator.full_name }}
						<button
							type="button"
							class="remove-btn"
							matChipRemove
							[attr.aria-label]="getRemoveLabel(moderator)">
							<span class="ficon-app-x" aria-hidden="true"></span>
						</button>
					</mat-chip-row>
				}
				<input
					#moderatorInput
					data-cy="activity-moderators-input"
					[formControl]="searchControl"
					[matAutocomplete]="moderatorAutocomplete"
					[matChipInputFor]="moderatorGrid"
					[placeholder]="'activity-editor-moderators-placeholder' | translate">
			</mat-chip-grid>
			<mat-autocomplete
				#moderatorAutocomplete="matAutocomplete"
				(optionSelected)="selectModerator($event)">
				@for (moderator of filteredModerators(); track moderator.user_id) {
					<mat-option class="activity-moderator-option" [value]="moderator">
						<span
							class="activity-moderators__option-name"
							[innerHTML]="moderator.full_name | highlight: searchControl.value">
						</span>
						<span
							class="activity-moderators__option-email"
							[innerHTML]="moderator.email | highlight: searchControl.value">
						</span>
					</mat-option>
				}
			</mat-autocomplete>
		</mat-form-field>
	}
</div>
